<template>
  <div>
    <vuex-breadcrumb></vuex-breadcrumb>
    <h1 id="jump-to-header">{{heading || "View"}}</h1>
    <product-listing-show :id="id" @gotAttrs="assignAttrs"></product-listing-show>
    <polymorphic-reference-index
      :filtering="filtering_reference"
      :ams_template="ams_template_reference"
     ></polymorphic-reference-index>
    <product-item-index
      :filtering="filtering"
      :ams_template="ams_template"
    ></product-item-index>
  </div>
</template>

<script>
import VuexBreadcrumb from './VuexBreadcrumb.vue'
import ProductListingShow from './ProductListingShow.vue'
import ProductItemIndex from './ProductItemIndex.vue'
import PolymorphicReferenceIndex from './PolymorphicReferenceIndex.vue'

export default {
  components: {
    VuexBreadcrumb,
    ProductListingShow,
    ProductItemIndex,
    PolymorphicReferenceIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      filtering: {
        product_listing_ids: this.id
      },
      ams_template: {
        type: 'product-items',
        description: undefined,
        attributes: {
          'product-listing-id': this.id,
          'storage-space-id': undefined,
          'purchased-price-cents': 0,
          'estimated-min-price-cents': 0,
          'estimated-max-price-cents': 0,
          'authenticated-min-price-cents': 0,
          'authenticated-max-price-cents': 0,
          'asking-price-cents': 0,
          'estimated-quality': 9000,
          'authenticated-quality': 0
        }
      },
      filtering_reference: {
        reference_to_type: 'ProductListing',
        reference_to_id: this.id
      },
      ams_template_reference: {
        type: 'polymorphic-references',
        descrition: undefined,
        attributes: {
          'reference-to-type': "ProductListing",
          'reference-to-id': this.id
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + '# ' + attrs['edition']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>